import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  padding: 0px 16px 0 16px;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const SecondContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const Button = styled.button`
  border-radius: 8px;
  background: #eaefff !important;
  height: 40px;
  cursor: pointer;
  width: 100%;
`;

export const ButtonBlue = styled.button`
  border-radius: 8px;
  background: #2d5bff !important;
  height: 40px;
  cursor: pointer;
  width: 100%;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const MinButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eaefff !important;
  height: 40px;
  cursor: pointer;
  width: 10%;
`;

export const LightTextBlue: any = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #2d5bff;
`;

export const LightText: any = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #eaefff;
`;
